import { Maybe, None } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
export class FocusAction extends BaseActionWithNav {
    constructor(map, layer, b_layer, s_layer) {
        super('FOCUS');
        this.map = map;
        this.layer = layer;
        this.b_layer = b_layer;
        this.s_layer = s_layer;
        this.focused = None.instance();
        this.message = {};
        this.exit_ctx = '';
    }
    validate(message) {
        return super.validate(message) && !!message.focused && message.focused.length > 0;
    }
    on_valid_message() {
        this.focused = Maybe(this.layer.clicked);
        this.b_layer.clear();
    }
    async singleton_ctx_handler(message) {
        if (this.s_layer.isLayerActive) {
            let cancel_button = $('#bld-move-cancel');
            if (cancel_button.length) {
                cancel_button.trigger('click');
                this.s_layer.remove();
                if ($('.toolBar').hasClass('hidden')) {
                    $('.toolBar').removeClass('hidden');
                }
            }
        }
        if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
            return;
        if (message.focused || message.force)
            this.layer.clear();
        await this.layer.select_feature(message.focused);
        await this.center_map_on_focused(message.focused);
        this.exit_ctx = 'singleton';
    }
    async set_ctx_handler(message) {
        if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
            return;
        if (message.focused && (!this.layer.ids.includes(message.focused) || message.force))
            this.layer.clear();
        await this.layer.select_feature(message.focused);
        await this.center_map_on_focused(message.focused);
        this.exit_ctx = this.layer.ids.length === 1 ? 'singleton' : '';
    }
    async selection_ctx_handler(message) {
        this.layer.clear();
        await this.layer.select_feature(message.focused);
        await this.center_map_on_focused(message.focused);
        this.exit_ctx = 'singleton';
    }
    async interpret(message) {
        this.message = message;
        const entry_ctx = this.ctx();
        if (entry_ctx.isNone()) {
            await this.layer.select_feature(message.focused);
            this.exit_ctx = 'singleton';
            return;
        }
        switch (entry_ctx.unwrap().name) {
            case 'singleton':
                await this.singleton_ctx_handler(message);
                break;
            case 'set':
                await this.set_ctx_handler(message);
                break;
            case 'selection':
                await this.selection_ctx_handler(message);
                break;
            default: {
                if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
                    return;
                if (message.focused && (!this.layer.ids.includes(message.focused) || message.force)) {
                    this.layer.clear();
                }
                await this.layer.select_feature(message.focused);
            }
        }
    }
    reset() {
        this.focused = None.instance();
        this.exit_ctx = '';
        this.message = {};
    }
    after_valid_message() {
        let ret_val = {
            zoom: true,
            center: this.message.force || false,
            context: this.exit_ctx,
            fail: false,
            navigate: None.instance()
        };
        this.reset();
        return ret_val;
    }
    async center_map_on_focused(id) {
        var _a, _b, _c;
        let feature = await this.layer.get_feature_by_id(id);
        if (feature.isSome()) {
            let polygon = feature.unwrap().getGeometry();
            if (!polygon) {
                return;
            }
            if (!polygon.getExtent()) {
                return;
            }
            const zoom_to_parcel_offset = (_c = (_b = (_a = this.map.getStrategy().config) === null || _a === void 0 ? void 0 : _a.Zoom) === null || _b === void 0 ? void 0 : _b.ZoomToParcelOffsetFromMaxZoom) !== null && _c !== void 0 ? _c : -2;
            const max_zoom = this.map.view.getMaxZoom();
            const zoom = Math.min(max_zoom, max_zoom + zoom_to_parcel_offset);
            this.map.getView().fit(polygon.getExtent(), {
                padding: [80, 80, 80, 80],
                maxZoom: zoom,
                duration: 50,
            });
        }
    }
}
